import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';

import { IRewardTokenBadge } from '../../models/reward-token-badge.model';

@Component({
    selector: 'bs-reward-used-badge',
    templateUrl: './result-reward-used-badge.component.html',
    styleUrls: ['./result-reward-used-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ResultRewardUsedBadgeComponent {
    @Input() badge: IRewardTokenBadge;

    readonly EntainUi = { showInEpcot: false, module: EpcotModule.Betslip };
    readonly EpcotUi = { showInEpcot: true, module: EpcotModule.Betslip };

    getBadgeCount(count: number): string {
        return `${count}x`;
    }
}
